export default __webpack_public_path__ + "static/media/directwire-withdraw.20446944.svg";